<template>
  <div class="yf-bar">
    <div class="yf-label">
      <fa :icon="['fas', 'filter']" class="yf-label-ico" />
      <span>Year</span>
    </div>
    <div class="yf-divider"></div>
    <div class="yf-items">
      <label
        v-for="year in years"
        :key="year"
        class="yf-item"
        :class="{ 'yf-item--on': selectedYears.includes(year) }"
      >
        <input
          type="checkbox"
          :value="year"
          v-model="selectedYears"
          @change="$emit('yearFilterChanged', selectedYears)"
        />
        <span class="yf-swatch" :style="{ background: yearColor(year) }"></span>
        <span class="yf-year">{{ year }}</span>
      </label>
    </div>
  </div>
</template>

<style scoped>
/* ── Bar wrapper ─────────────────────────────────────── */
.yf-bar {
  display: inline-flex;
  align-items: center;
  gap: 0;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(8px);
  border: 1px solid rgba(6, 60, 109, 0.15);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(6, 60, 109, 0.12);
  padding: 0.375rem 0.625rem;
  font-family: system-ui, -apple-system, sans-serif;
  overflow: hidden;
}

/* ── "Year" label on the left ────────────────────────── */
.yf-label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.1875rem;
  padding-right: 0.625rem;
  /* color: rgba(6, 60, 109, 0.55); */
  color: #063c6d;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  flex-shrink: 0;
}

.yf-label-ico {
  font-size: 0.75rem;
  /* color: rgba(6, 60, 109, 0.45); */
  color: #063c6d;
}

/* ── Vertical divider ────────────────────────────────── */
.yf-divider {
  width: 1px;
  height: 2.25rem;
  background: rgba(6, 60, 109, 0.15);
  margin-right: 0.5rem;
  flex-shrink: 0;
}

/* ── Items row ───────────────────────────────────────── */
.yf-items {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  overflow-x: auto;
  scrollbar-width: none;
}
.yf-items::-webkit-scrollbar { display: none; }

/* ── Individual year pill ────────────────────────────── */
.yf-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0.25rem 0.4375rem;
  border-radius: 7px;
  cursor: pointer;
  user-select: none;
  flex-shrink: 0;
  border: 1px solid transparent;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.yf-item input[type="checkbox"] {
  display: none;
}

.yf-item:hover {
  background: rgba(6, 60, 109, 0.06);
}

.yf-item--on {
  background: rgba(6, 60, 109, 0.06);
  border-color: rgba(6, 60, 109, 0.25);
}

.yf-item:not(.yf-item--on) .yf-swatch {
  opacity: 0.25;
}

.yf-item:not(.yf-item--on) .yf-year {
  opacity: 0.35;
}

/* ── Color swatch line ───────────────────────────────── */
.yf-swatch {
  width: 2rem;
  height: 0.25rem;
  border-radius: 2px;
  transition: opacity 0.15s ease;
}

/* ── Year number ─────────────────────────────────────── */
.yf-year {
  font-size: 0.68rem;
  font-weight: 700;
  color: #063c6d;
  letter-spacing: 0.01em;
  transition: opacity 0.15s ease;
}
</style>

<script>
const YEAR_COLORS = {
  2014: '#708090',
  2015: '#000000',
  2016: '#6F452B',
  2017: '#E9BD02',
  2018: '#00E5FF',
  2019: '#6F067B',
  2020: '#BA831F',
  2021: '#00B1AE',
  2022: '#E5571D',
  2023: '#B91E02',
  2024: '#e15dd3',
  2025: '#45db24',
  2026: '#168be1',
}

export default {
  name: 'TRT_YearFilter',
  data() {
    const currentYear = new Date().getFullYear()
    const years = []
    for (let y = 2014; y <= currentYear; y++) {
    // for (let y = currentYear; y >= 2014; y--) {
      years.push(y)
    }
    return {
      years,
      selectedYears: [...years]
    }
  },
  methods: {
    yearColor(year) {
      return YEAR_COLORS[year] || '#aaa'
    }
  }
}
</script>
